

















































































































import Vue from 'vue';
import validators, { ssnPattern } from '@/validators';
import { Donor } from '@/interfaces/donation/donor';
import { mask } from 'vue-the-mask';
import { stepV1, stepV2 } from '@/enums/donationStepOrder';
import { getFromSpar } from '@/api/mainApi';
import { RequestSession } from '@/interfaces/requestSession';
import ConfirmFieldComponent from '@/components/form/ConfirmFieldComponent.vue';
import { DonationStepFlowVersion } from '@/enums/donationStepFlowVersion';
import StepperFlowMixin from '@/mixins/donationStepperFlowMixin';

export default Vue.extend({
  components: {
  },
  directives: {
    mask,
  },
  mixins: [StepperFlowMixin],
  props: {
    value: {
      type: Object as () => Donor,
    },
    error: {
      type: Boolean,
      default: false,
    },
    showPersonalIdentityNumberField: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      ssnLoading: false,
      ssnMask: this.$t('generic.masks.ssn') as string,
      ssnValid: false,
      rules: {},
      confirmEmail: "",
    };
  },
  computed: {
    steps(): typeof stepV1 | typeof stepV2 {
      return this.donationStepFlowVersion == DonationStepFlowVersion.V1 ? stepV1 : stepV2;
    },
    socialSecurityNumber() {
      return this.donor.socialSecurityNumber;
    },
    currentStep() {
      return this.$store.state.currentStep;
    },
    requestSession(): RequestSession {
      return this.$store.state.requestSession;
    },
    isDirectPaymentAvailable() {
      return (
        this.requestSession.organizationGroup &&
        this.requestSession.organizationGroup.swedbankPaySettings &&
        this.requestSession.organizationGroup.swedbankPaySettings.id
      );
    },
    donor: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('update:value', val);
      },
    },
    showError: {
      get() {
        return this.error;
      },
      set(val) {
        this.$emit('update:error', val);
      },
    },
    donorEmail: {
      get() {
        return this.donor.email;
      },
      set(newValue) {
        this.donor.email = newValue;
      },
    },
  },
  watch: {
    currentStep(val) {
      if (val == this.steps.DONOR) {
        this.$refs.ssn.focus();
      }
    },
    async socialSecurityNumber(newValue, oldValue) {
      let newValueExclHypen = newValue.replace(/-/g, '');
      let oldValueExclHypen = oldValue.replace(/-/g, '');
      if (newValueExclHypen !== oldValueExclHypen || this.showError) {
        this.showError = false;
        if (ssnPattern.test(newValue)) {
          this.ssnValid = true;
          this.ssnLoading = true;
          let formattedSsn: string = newValue.replace('-', '');
          getFromSpar(formattedSsn)
            .then(data => {
              data.socialSecurityNumber = newValue;
              this.donor = data;
              if (!this.isDirectPaymentAvailable && data.givenName && data.givenName.length > 0) {
                this.$nextTick(() => {
                  // must be nextTick so we update data after its been assigned
                  this.donor.firstname = data.givenName;
                });
              }

              this.$refs.email.focus();
            })
            .catch(error => {
              this.showError = true;
            })
            .finally(() => {
              this.ssnLoading = false;
            });
        }
        else {
          this.ssnValid = false;
          this.showError = true;
        }
      }
    }
  },
  created() {
    // NOTE: This might be an issue if language is to be changed runtime
    Object.assign(this.rules, validators(this.$t('validation')));
  },
  methods: {
    t(label) {
      const $te = this.$te.bind(this);
      const $t = this.$t.bind(this);
      return $te(label) ? $t(label) : undefined;
    },
  },
});
